export default __webpack_public_path__ + "static/media/success_mark.2e114d99.svg";